import { render, staticRenderFns } from "./BezoekersLocatieBundle.vue?vue&type=template&id=6c2781bc&"
import script from "./BezoekersLocatieBundle.vue?vue&type=script&lang=js&"
export * from "./BezoekersLocatieBundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports